module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSI+DQogIDxjaXJjbGUgY3g9IjUwJSIgY3k9IjUwJSIgcj0iNDUlIiBzdHJva2U9IiNGRjhGM0IiDQogIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0iI2ZmZmZmZiIvPg0KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/circle.svg
// module id = 857
// module chunks = 18